import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Link } from 'foundations-components/transitional/components/Link';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { getBreezeStudioUrl } from 'marketplace-ui-common/utils/DetailsPageUrls';
import { useOpenCopilot } from 'copilot-toolkit/hooks/useOpenCopilot';
// Temporary beta import: Remove after beta rollout, then make BreezeAssistantAlert the default.
import { useBreezeAssistantBetaListing } from './useBreezeAssistantBetaListing';

// Post-beta: Remove the Badge import, the beta Badge from titleText, and rename to McpServerConnectAlert.
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BreezeAssistantAlert() {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const openCopilot = useOpenCopilot();
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "600",
    type: "info",
    titleText: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.mcpServerBreezeAssistantBetaAlert.title"
      }), ' ', /*#__PURE__*/_jsx(Badge, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerBreezeAssistantBetaAlert.betaBadge"
        })
      })]
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "detailsPage.mcpServerBreezeAssistantBetaAlert.description_jsx",
      elements: {
        Link
      },
      options: {
        linkProps: {
          onClick: () => {
            openCopilot();
            trackInteraction({
              action: 'click breeze assistant link in mcp server beta alert'
            });
          }
        }
      }
    })
  });
}

// Temporary: Remove this entire function and the BreezeStudioAlert block below after beta rollout.
// BreezeAssistantAlert above becomes the sole export renamed to McpServerConnectAlert.
function BreezeStudioAlert() {
  const {
    name,
    trackInteraction
  } = useDetailsPageContext();
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "600",
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.mcpServerConnectAlert.title",
      options: {
        appName: name
      }
    }),
    children: /*#__PURE__*/_jsxs("ol", {
      children: [/*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step1",
          options: {
            appName: name
          }
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.mcpServerConnectAlert.step2_jsx",
          elements: {
            Link
          },
          options: {
            linkProps: {
              href: getBreezeStudioUrl(),
              external: true,
              hideExternalLinkIcon: true,
              onClick: () => {
                trackInteraction({
                  action: 'click breeze studio link in mcp server connect alert'
                });
              }
            }
          }
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step3"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step4"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.mcpServerConnectAlert.step5",
          options: {
            appName: name
          }
        })
      })]
    })
  });
}
export function McpServerConnectAlert() {
  const isBreezeAssistantBeta = useBreezeAssistantBetaListing();

  // Temporary: Remove this conditional after beta rollout.
  // Just return <BreezeAssistantAlert /> directly (renamed to McpServerConnectAlert).
  if (!isBreezeAssistantBeta) {
    return /*#__PURE__*/_jsx(BreezeStudioAlert, {});
  }
  return /*#__PURE__*/_jsx(BreezeAssistantAlert, {});
}